import React from 'react';
import htmlParser, { domToReact } from 'html-react-parser';

export const configureHtmlText = (components = {}) => ({ children }) => {
  const parserOptions = {
    replace: ({name, attribs, children, type, ...rest}) => {
      if (type !== 'tag') { return; }
      const nameLower = name.toLowerCase();
      const ReplaceNode = components[nameLower];
      if (ReplaceNode) {
        return <ReplaceNode {...attribs}>{domToReact(children, parserOptions)}</ReplaceNode>;
      }
    }
  };
  return htmlParser(children, parserOptions);
};

export const HtmlText = configureHtmlText({});

export default HtmlText;
